"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestTimeOffsById = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const query_1 = __importDefault(require("./query"));
const TIME_OFFS_BY_ID_QUERY = (0, graphql_tag_1.default) `
  query TimeOffsById($workspaceId: ID!, $ids: [ID!]) {
workspace(id: $workspaceId) {
  timeOffs(ids: $ids) ${query_1.default.TIME_OFF}
}
}`;
const requestTimeOffsById = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(TIME_OFFS_BY_ID_QUERY, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.workspace.timeOffs;
};
exports.requestTimeOffsById = requestTimeOffsById;
const requestTimeOffsByIdMap = async (variables, _) => await (0, exports.requestTimeOffsById)(variables);
// async function requestTimeOffsById(variables, token) {
//   const response = await fetchRequest({
//     query: TIME_OFFS_BY_ID_QUERY,
//     variables,
//     token,
//   })
//   if (!response) return errUtil.noResponse()
//   const { errors, data } = response
//   if (errors) {
//     return errUtil.apiError('timeOffs', errors)
//   }
//   return data.workspace.timeOffs
// }
exports.default = requestTimeOffsByIdMap;
